import { redirect, type LoaderFunctionArgs } from "react-router";
import { getApiV1GamesById } from "../../client";
import { apiData } from "../../utils/api";
import { Error } from "../utils/Error";
import { OutletOrChildren } from "../utils/OutletOrChildren";

export { RouteErrorBoundary as ErrorBoundary } from "../utils/RouteErrorBoundary";

// Fetched on the server during SSR (and on the server again for client-side
// navigations), so the rendered page is never a client-only loading spinner.
export async function loader({ params }: LoaderFunctionArgs) {
    if (!params.gameId) {
        throw new Response("Game not found!", { status: 404 });
    }

    // The release child route fetches the game on its own; only resolve the
    // bare /games/:gameId request here by forwarding to the latest release.
    if (!params.releaseId) {
        const game = await apiData(getApiV1GamesById({ path: { id: params.gameId } }));
        if (game.releases.length > 0) {
            throw redirect(`/games/${game.id}/releases/${game.releases[0].id}`);
        }
        return game;
    }

    return null;
}

export function Game() {
    // The loader forwards bare /games/:gameId URLs to the latest release; a
    // game can only render here (without a child outlet) if it has none.
    return (
        <OutletOrChildren>
            <Error error={"This game has no releases!"} />
        </OutletOrChildren>
    );
}

export default Game;
